(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('WeeklyReportsController', ["$scope", "$location", "http", "tablePaginationHelper", "defaultListConverter", "$q", "modals", function ($scope, $location, http, tablePaginationHelper, defaultListConverter, $q, modals) {
        $scope.options = {
            columns: [
                {
                    id: 'Date',
                    hidden: true
                },
                {
                    id: 'subject',
                    text: 'Subject',
                    converter: 'getSubject'
                },
                {
                    id: 'report_date',
                    text: 'Date',
                    converter: 'localTimeFromFileName'
                },
                {
                    id: 'Key',
                    text: 'Name',
                    converter: 'clickEventConverter',
                    converterArgs: {
                        eventName: 'view-weekly-report',
                        class: 'link-like',
                        iconClass: 'weekly-report-icon',
                        pdfIcon: true,
                        noText: true,
                        attributes: { fileName: 'Key' }
                    }
                }
            ],
            options: {
                defaultOrdering: {
                    columnName: 'Key',
                    order: 'desc'
                }
            }
        };
        $scope.tableOptions = {
            disableTop: true,
            disableTotalRows: false,
            orderDisplayMode: 'highlight-column',
            asDivs: false,
            infinite: false,
            reloadUuid: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            dropdownHeader: true,
            pagesAround: 2,
            pageSize: 20,
            pagination: {
                page: 1,
                ordering: {}
            }
        };
        $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
            return http.get('/api/v1/mta/get_all_reports').pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(function (input, args) {
                var inputData = input && input.data;
                var newData = _(inputData).reject(function (data) {
                    return !data.Key;
                });
                return $q.when({ data: newData });
            }).converter(defaultListConverter, {
                columns: $scope.options.columns,
                converters: {
                    localTimeFromFileName: function (text, columnId, columnsMap) {
                        var dateText = '';
                        if (columnsMap.Key) {
                            var arr = columnsMap.Key.split('_weeklyreport.pdf');
                            dateText = arr[0];
                            if (dateText) {
                                var convertedTime = moment.utc(dateText.trim()).format('YYYY-MM-DD');
                                return '#' + JSON.stringify({
                                    'display': 'text',
                                    'class': 'one-line-date',
                                    'text': convertedTime
                                });
                            }
                        }
                        return '#' + JSON.stringify({
                            'display': 'text',
                            'text': ''
                        });
                    },
                    getSubject: function (text, columnId, columnsMap) {
                        var dateText = '';
                        if (columnsMap.Key) {
                            var arr = columnsMap.Key.split('_weeklyreport.pdf');
                            dateText = arr[0];
                            if (dateText && dateText.indexOf('-') !== -1) {
                                return '#' + JSON.stringify({
                                    'display': 'text',
                                    'text': 'Monthly reports'
                                });
                            }
                        }
                        return '#' + JSON.stringify({
                            'display': 'text',
                            'text': 'Weekly report'
                        });
                    }
                }
            });
        }, function (tableModel) {
            $scope.tableModel = tableModel;
        });
        $scope.$on('view-weekly-report', function (event, data) {
            if (data && data.attributes && data.attributes.fileName) {
                return http.get('/api/v1/mta/get_report').params({ path: data.attributes.fileName }).then(function (response) {
                    if (response.data && response.data.data && response.data.data !== 'Error Downloding file') {
                        modals.pdfViewer(response.data.data, {
                            title: 'Weekly report',
                            hideBottom: true,
                            enableDownload: true,
                            fileName: data.attributes.fileName
                        }, 'xlg');
                    } else {
                        console.log('Error Downloading file');
                    }
                }, function (err) {
                    console.log('Error on getting PDF file.', err);
                });
            }
        });
    }]);
}());